enum ProgressFor {
	Sales,
	Delivery,
	Activity,
	PinkSheets,
	Curriculum,
}


export default ProgressFor;